const CHAT_FLOW_STEPS = {
  booting: 'booting',
  organizationSelection: 'organizationSelection',
  chatInit: 'chatInit',
  chatLoad: 'chatLoad',
  chatStart: 'chatStart',
  quickActionSelection: 'quickActionSelection',
  showWelcomeMessage: 'showWelcomeMessage',
  greeting: 'greeting',
  chatQuestion: 'chatQuestion',
  makePrediction: 'makePrediction',
  requestIntentSelection: 'requestIntentSelection',
  requestCategory: 'requestCategory',
  requestVisitorRole: 'requestVisitorRole',
  requestName: 'requestName',
  requestEmail: 'requestEmail',
  connectingExpert: 'connectingExpert',
  chat: 'chat',
  closeChat: 'closeChat',
  rateBadChat: 'rateBadChat',
  rateChat: 'rateChat',
  chatEnd: 'chatEnd',
  hasError: 'hasError',
  quickActionPredict: 'quickActionPredict',
} as const;

type ChatFlowStep = (typeof CHAT_FLOW_STEPS)[keyof typeof CHAT_FLOW_STEPS];

// eslint-disable-next-line import/prefer-default-export
export { CHAT_FLOW_STEPS, type ChatFlowStep };
